import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import '../css/LitaratureReview.css';
import AshadL from './AshadL';
import ZahidL from './ZahidL';
import MayeshaL from './MayeshaL';

function LitaratureReview() {
  return (
    <div className="l-r-s-div">
      <Tabs
        defaultActiveKey="longer-tab"
        transition={false}
        id="justify-tab-example"
        className="mb-3 my-litarature-tabs"
        justify
      >
        <Tab eventKey="home" title="Md. Ashaduzzaman Nur" className="my-litarature-tab">
          <AshadL />
        </Tab>
        <Tab eventKey="profile" title="Kazi Mayesha Mehzabin" className="my-litarature-tab">
          <MayeshaL />
        </Tab>
        <Tab eventKey="longer-tab" title="Md. Zahidul Islam" className="my-litarature-tab">
          <ZahidL />
        </Tab>

        <Tab eventKey="contact" title="Saniul Islam Sani" className="my-litarature-tab">
          No Content Available
        </Tab>
      </Tabs>
    </div>
  );
}

export default LitaratureReview;
